import React, { Suspense, lazy } from "react";
import AuthLayout from "../layout/AuthLayout";
import Loader from "../utils/Loader";
import { Route, Routes } from "react-router-dom";
import FlightsHome from "../components/flights/landingpage/Home";
import Result from "../components/flights/resultpage/Result";
import HotelsHome from "../components/hotels/landingpage/HotelsHome";
import HotelResult from "../components/hotels/resultHotelpage/HotelResult";
// import BookingSuccess from "../components/hotels/BookingSuccesspage/BookingSuccess";
// import BusHome from "../components/bus/landingpage/BusHome";
// import BusResult from "../components/bus/busresultpage/BusResult";
// import BusConfirm from "../components/bus/confirmpage/BusConfirm";
import HolidayHome from "../components/holiday/landingpage/HolidayHome";
import PackageHome from "../components/holiday/packagepage/PackageHome";
import AdventureTourPackages from "../components/holiday/packagepage/AdventureTourPackages";
import HolidayConfirm from "../components/holiday/confirmpage/HolidayConfirm";
import Profile from "../layout/Profile";
import MyBooking from "../layout/MyBooking";
import MyWallet from "../layout/MyWallet";
import AboutUs from "../components/SiteInformation/AboutUs";
import ContactUs from "../components/SiteInformation/ContactUs";
import TermsConditions from "../components/SiteInformation/TermsConditions";
import PrivacyPolicy from "../components/SiteInformation/PrivacyPolicy";
import UserAgreement from "../components/SiteInformation/UserAgreement";
import RefundPolicy from "../components/SiteInformation/RefundPolicy";
import TripjeckTBOReviewPage from "../components/flights/resultpage/TripjeckTBOReviewPage";
import PopularDomesticFlight from "../components/flights/PopularDomesticFlight/PopularDomesticFlight";
import PopularInternationalFlight from "../components/flights/popularInternationalFlight/PopularInternationalFlight";
import AllDomesticPackage from "../components/holiday/landingpage/AllDomesticPackage";
import AllInternatinalPackage from "../components/holiday/landingpage/AllInternatinalPackage";
import AllHolidayPackagesbyTheme from "../components/holiday/landingpage/AllHolidayPackagesbyTheme";
import DestinationDetails from "../components/holiday/landingpage/DestinationDetails";
import AllPackagesbyDestination from "../components/holiday/landingpage/AllPackagesbyDestination";
import Offers from "../components/Offers/Offers";
import DownloadTicketPDF from "../components/auth/DownloadTicketPDF";
import FeaturedIn from "../components/SiteInformation/FeaturedIn";
import Certificates from "../components/SiteInformation/Certificates";
// import { Helmet } from "react-helmet-async";
import { useLocation } from 'react-router-dom';
import PageNotFound from "./PageNotFound";
import PaymentStatus from "../components/flights/bookingpagetripJack/PaymentStatus";
import ProtectedRoute from "./ProtectedRoute";
import TripjeckTBOHotelReview from "../components/hotels/resultHotelpage/TripjeckTBOHotelReview";
import HotelPaymentTripjackTbo from "../components/hotels/PaymentHotelpage/HotelPaymentTripjackTbo";
import { airlineAssets } from "../components/flights/airlinepages/AirlineAssetsConfig";
import AirlineFlightBookingPage from "../components/flights/airlinepages";

const PrivateRoutes = () => {

  const location = useLocation();
  // const canonicalUrl = `${window.location.origin}${location.pathname}`;
  // let tokenId = JSON.parse(localStorage.getItem("tokenId"));

  return (
    <Suspense fallback={<Loader />}>
      {/* <Helmet>
        <link rel="canonical" href={canonicalUrl} />
      </Helmet> */}

      <Routes>
        <Route element={<AuthLayout />}>
          {/* flight components */}
          <Route path="" element={<FlightsHome />} />
          <Route path="flights" element={<FlightsHome />} />
          {Object?.entries(airlineAssets)?.map(([name, { slug }]) => (<Route key={slug} path={slug} element={<AirlineFlightBookingPage initialAirline={name} />} />))}
          <Route path="flights/:id" element={<Result />} />
          <Route path="flight-review" element={<TripjeckTBOReviewPage />} />

          {/* hotel components */}
          <Route path="hotels" element={<HotelsHome />} />
          <Route path="hotels/:id" element={<HotelResult />} />
          <Route path=":countrySlug/:citySlug" element={<HotelResult />} />
          <Route path="hotel-details" element={<TripjeckTBOHotelReview />} />
          <Route path="hotel-payment" element={<HotelPaymentTripjackTbo />} />
          {/* <Route path="hotel-payment" element={<HotelPaymentTbo />} /> */}

          {/* Bus components */}
          {/* <Route path="bus" element={<BusHome />} />
          <Route path="bus-result" element={<BusResult />} />
          <Route path="bus-confirm" element={<BusConfirm />} /> */}

          {/* holiday components */}
          <Route path="holiday" element={<HolidayHome />} />
          <Route path="package-home" element={<PackageHome />} />
          <Route path="HolidayConfirm" element={<HolidayConfirm />} />
          <Route path="package-details/:id" element={<HolidayConfirm />} />
          <Route path="adventure-tour-packages" element={<AdventureTourPackages />} />
          <Route path="holiday-packages-domestic-destination" element={<AllDomesticPackage />} />
          <Route path="holiday-packages-international-destination" element={<AllInternatinalPackage />} />
          <Route path="holiday-packages-by-theme" element={<AllHolidayPackagesbyTheme />} />
          <Route path="holidays-by-destination" element={<AllPackagesbyDestination />} />
          <Route path="package/:id" element={<PackageHome />} />
          <Route path="destination/:id" element={<DestinationDetails />} />

          {/* Auth components */}
          <Route
            path="create-profile"
            element={<Profile />}
          />
          <Route
            path="my-booking"
            element={<ProtectedRoute><MyBooking /> </ProtectedRoute>}
          />
          <Route
            path="my-wallet"
            element={<ProtectedRoute> <MyWallet /></ProtectedRoute>}
          />
          <Route path="paymentstatus/:id" element={<PaymentStatus />} />

          {/* Site Information components */}
          <Route path="about-us" element={<AboutUs />} />
          <Route path="contact-us" element={<ContactUs />} />
          <Route path="privacy-policy" element={<PrivacyPolicy />} />
          <Route path="terms-conditions" element={<TermsConditions />} />
          <Route path="featured-in" element={<FeaturedIn />} />
          <Route path="certificates" element={<Certificates />} />
          <Route path="user-agreement" element={<UserAgreement />} />
          <Route path="refund-policy" element={<RefundPolicy />} />
          <Route path="popular-international-destinations" element={<PopularInternationalFlight />} />
          <Route path="popular-domestic-destinations" element={<PopularDomesticFlight />} />
          <Route path="offers" element={<Offers />} />
          <Route path="donwload-ticket" element={<DownloadTicketPDF />} />
          <Route path="donwload-ticket/:id" element={<DownloadTicketPDF />} />

          <Route path="*" element={<PageNotFound />} />

        </Route>
      </Routes>

    </Suspense>
  );
};

export default PrivateRoutes;